export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-5-037ef6b24e86a251b4befab5f9487c0a.jpg";